import { Box, Paper } from "@mui/material";
import IceExhcnageTrades from "./TradeCaptureAPI/IceExhcnageTrades";

const TradeCaptureApi = () => {
  return (
    <div className="page-body" style={{ paddingTop: 0 }}>
      <div >
        <Box>
          {/* ---- Content Section ---- */}
          <Paper
            elevation={0}
            sx={{
              backgroundColor: "#ffffff",
              p: 1,
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              minHeight: 200,
              width: "100%",
              overflowX: "auto",
              boxSizing: "border-box",
            }}
          >
            <Box sx={{ width: "100%", mt: 0, pt: 0 }}>
              <IceExhcnageTrades />
            </Box>
          </Paper>
        </Box>
      </div>
    </div>
  );
};

export default TradeCaptureApi;
